import { Component, OnChanges, Input } from '@angular/core';
import { PHBHPFeaturePackageAuthorizationService } from "../ph-bhp-feature-package-authorization.service"
import { PHBHPLayoutPackageService as layoutService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lib-ph-bhp-reset-password',
  templateUrl: './ph-bhp-reset-password.component.html',
  styleUrls: ['./ph-bhp-reset-password.component.css']
})
export class PhBhpResetPasswordComponent implements OnChanges {
  @Input() validationKey: string;
  @Input() languageCode: string;
  isSuccess = false;
  isSubscribe = false;
  constructor(private service: PHBHPFeaturePackageAuthorizationService, private data: layoutService, public translate: TranslateService) { }

  ngOnChanges() {
    this.data.showLoader = true;
    if (this.languageCode) {
      localStorage.setItem("selectedlanguage", this.languageCode);
      this.translate.use(this.languageCode);
    }

    this.service.passwordReset(this.validationKey).subscribe((res) => {
      this.data.showLoader = false;
      this.isSuccess = res;
      this.isSubscribe = true;
    })
  }
}
